import { gql } from "@apollo/client";

export const IS_AUTH_QUERY = gql`
  query getUser {
    isAuthenticated {
      status
    }
    getUserByToken {
      accountingFirms
      companies
      isActive
      userCategory {
        id
        name
        slug
      }
      isSuperuser
      id
      firstName
      lastName
      email
      username
      permissions
      language
    }
  }
`;

export const LIST_APPS_QUERY = gql`
  query listApplications($isHidden: Boolean) {
    listApplications(filter: { isHidden: $isHidden }) {
      id
      name
      url
      slug
      logo
      order
      inDevelopment
      pathOption
      category {
        slug
      }
    }
    listApplicationCategories {
      slug
      name
      order
    }
  }
`;
